import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(12),
  },
  thumbnail: {
    width: "60px",
    height: "auto",
    objectFit: "cover",
    borderRadius: "0.5rem",
    transition: "all 0.3s ease",
  },
  description: {
    flex: 1,
    padding: theme.spacing(0, 4),
    margin: 0,
    fontSize: "0.875rem",
    color: "#0A1A2F",
  },
}));
